import React from 'react'
import Import from 'ui/views/import/Import'

export default function ImportPage() {
  return <Import />
}
